(function() {
  'use strict';
  
  // CRITICAL: Prevent double initialization - MUST BE FIRST
  if (window.WISHLIST_INITIALIZED) {
    console.log('✅ Wishlist already loaded, skipping duplicate');
    return;
  }
  window.WISHLIST_INITIALIZED = true;

  console.log('Initializing Wishlist System...');

  // Private variables - scoped to this IIFE only
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  let isExpanded = false;

  // Update counter display
  function updateWishlistCount() {
    const counter = document.querySelector('.wishlist-count');
    const number = document.querySelector('.wishlist-count-number');
    const expandedCount = document.getElementById('wishlist-expanded-count');
    
    if (counter && number) {
      number.textContent = wishlist.length;
      counter.style.display = wishlist.length > 0 ? 'inline-flex' : 'none';
      
      if (expandedCount) {
        expandedCount.textContent = wishlist.length;
      }
    }
  }

  // Handle wishlist icon clicks
  document.addEventListener('click', function(e) {
    const wishlistBtn = e.target.closest('.wishlist-icon');
    if (!wishlistBtn) return;
    
    e.preventDefault();
    
    const productId = wishlistBtn.getAttribute('data-product-id');
    const isInWishlist = wishlist.includes(productId);
    
    if (isInWishlist) {
      // Remove from wishlist
      wishlist = wishlist.filter(id => id !== productId);
      wishlistBtn.classList.remove('active');
    } else {
      // Add to wishlist
      wishlist.push(productId);
      wishlistBtn.classList.add('active');
      
      // Store product data for display
      const productCard = wishlistBtn.closest('.product-card') || wishlistBtn.closest('[data-product-id]');
      if (productCard) {
        const productData = {
          id: productId,
          title: productCard.querySelector('.product-card__title, h3, h4')?.textContent?.trim() || 'Product',
          price: productCard.querySelector('.product-card__price, .price')?.textContent?.trim() || '',
          image: productCard.querySelector('img')?.src || '',
          url: productCard.querySelector('a')?.href || '#'
        };
        
        let wishlistData = JSON.parse(localStorage.getItem('wishlistData')) || [];
        wishlistData = wishlistData.filter(item => item.id !== productId);
        wishlistData.push(productData);
        localStorage.setItem('wishlistData', JSON.stringify(wishlistData));
      }
    }
    
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    updateWishlistCount();
    
    if (isExpanded) {
      loadWishlistContent();
    }
  });

  // Load wishlist content into expanded view - NOW USES CSS CLASSES
  function loadWishlistContent() {
    const grid = document.getElementById('wishlist-expanded-grid');
    const emptyState = document.getElementById('wishlist-expanded-empty');
    
    if (!grid || !emptyState) return;
    
    const wishlistData = JSON.parse(localStorage.getItem('wishlistData')) || [];
    
    if (wishlist.length === 0) {
      grid.innerHTML = '';
      emptyState.style.display = 'block';
      return;
    }
    
    emptyState.style.display = 'none';
    
    const html = wishlist.map(productId => {
      const data = wishlistData.find(item => item.id === productId);
      
      if (data) {
        return `
          <div class="wishlist-item-card">
            <button onclick="removeFromWishlist('${productId}')" class="wishlist-item-remove">×</button>
            ${data.image ? `<img src="${data.image}" alt="${data.title}" class="wishlist-item-image">` : 
              '<div class="wishlist-item-placeholder">No Image</div>'}
            <h4 class="wishlist-item-title">${data.title}</h4>
            ${data.price ? `<div class="wishlist-item-price">${data.price}</div>` : ''}
            <div class="wishlist-item-actions">
              <a href="${data.url}" class="wishlist-view-btn">View Product</a>
            </div>
          </div>
        `;
      }
      
      return `
        <div class="wishlist-item-card">
          <button onclick="removeFromWishlist('${productId}')" class="wishlist-item-remove">×</button>
          <div class="wishlist-item-placeholder">Product</div>
          <h4 class="wishlist-item-title">Product #${productId}</h4>
        </div>
      `;
    }).join('');
    
    grid.innerHTML = html;
  }

  // Toggle wishlist section (exposed globally)
  window.toggleWishlistSection = function() {
    const section = document.getElementById('wishlist-expanded-section');
    const arrow = document.querySelector('.wishlist-arrow');
    
    if (!section) {
      console.error('Wishlist section not found');
      return;
    }
    
    if (!isExpanded) {
      section.style.display = 'block';
      setTimeout(() => {
        section.style.opacity = '1';
        section.style.maxHeight = '600px';
      }, 10);
      
      if (arrow) arrow.style.transform = 'rotate(180deg)';
      loadWishlistContent();
      isExpanded = true;
      
      setTimeout(() => {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    } else {
      section.style.opacity = '0';
      section.style.maxHeight = '0';
      if (arrow) arrow.style.transform = 'rotate(0deg)';
      
      setTimeout(() => {
        section.style.display = 'none';
      }, 300);
      
      isExpanded = false;
    }
  };

  // Remove from wishlist (exposed globally)
  window.removeFromWishlist = function(productId) {
    wishlist = wishlist.filter(id => id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    
    let wishlistData = JSON.parse(localStorage.getItem('wishlistData')) || [];
    wishlistData = wishlistData.filter(item => item.id !== productId);
    localStorage.setItem('wishlistData', JSON.stringify(wishlistData));
    
    document.querySelectorAll(`[data-product-id="${productId}"].wishlist-icon`).forEach(icon => {
      icon.classList.remove('active');
    });
    
    updateWishlistCount();
    
    if (isExpanded) {
      loadWishlistContent();
    }
  };

  // Clear all wishlist (exposed globally)
  window.clearAllWishlist = function() {
    wishlist = [];
    localStorage.setItem('wishlist', JSON.stringify([]));
    localStorage.removeItem('wishlistData');
    
    document.querySelectorAll('.wishlist-icon.active').forEach(icon => {
      icon.classList.remove('active');
    });
    
    updateWishlistCount();
    
    if (isExpanded) {
      loadWishlistContent();
    }
  };

  // Initialize on load
  function initialize() {
    wishlist.forEach(productId => {
      const btn = document.querySelector(`[data-product-id="${productId}"].wishlist-icon`);
      if (btn) btn.classList.add('active');
    });
    updateWishlistCount();
  }

  // Run initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  console.log('Wishlist system initialized with', wishlist.length, 'items');

})();